export default __webpack_public_path__ + "static/Chupa_Chups_Lemon-e12c90f72bd8091af505b60ade169016.png";